/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListFineTuningCheckpointsRequest = {
  fineTuningJobId: string;
  after?: string | null | undefined;
  limit?: number | undefined;
};

/** @internal */
export const ListFineTuningCheckpointsRequest$inboundSchema: z.ZodType<
  ListFineTuningCheckpointsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  fine_tuning_job_id: z.string(),
  after: z.nullable(z.string()).optional(),
  limit: z.number().int().default(10),
}).transform((v) => {
  return remap$(v, {
    "fine_tuning_job_id": "fineTuningJobId",
  });
});
/** @internal */
export type ListFineTuningCheckpointsRequest$Outbound = {
  fine_tuning_job_id: string;
  after?: string | null | undefined;
  limit: number;
};

/** @internal */
export const ListFineTuningCheckpointsRequest$outboundSchema: z.ZodType<
  ListFineTuningCheckpointsRequest$Outbound,
  z.ZodTypeDef,
  ListFineTuningCheckpointsRequest
> = z.object({
  fineTuningJobId: z.string(),
  after: z.nullable(z.string()).optional(),
  limit: z.number().int().default(10),
}).transform((v) => {
  return remap$(v, {
    fineTuningJobId: "fine_tuning_job_id",
  });
});

export function listFineTuningCheckpointsRequestToJSON(
  listFineTuningCheckpointsRequest: ListFineTuningCheckpointsRequest,
): string {
  return JSON.stringify(
    ListFineTuningCheckpointsRequest$outboundSchema.parse(
      listFineTuningCheckpointsRequest,
    ),
  );
}
export function listFineTuningCheckpointsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListFineTuningCheckpointsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListFineTuningCheckpointsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListFineTuningCheckpointsRequest' from JSON`,
  );
}
